"use client";

export default function GlobalError({
  reset
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <html lang="en">
      <body>
        <main style={{ minHeight: "100vh", display: "grid", placeItems: "center", padding: 24, fontFamily: "system-ui, sans-serif" }}>
          <section style={{ maxWidth: 560 }}>
            <p style={{ color: "#b91c1c", fontWeight: 800, textTransform: "uppercase", letterSpacing: "0.14em" }}>Application error</p>
            <h1>Something failed while rendering the app.</h1>
            <p>Please retry the page. The error boundary prevented a blank screen.</p>
            <button type="button" onClick={reset}>Try again</button>
          </section>
        </main>
      </body>
    </html>
  );
}
